module.exports = __webpack_public_path__ + "static/logo@2x-37464e2b4af25d33b01d60250b3f95e9.png";